import React from 'react';
import './App.css';
import AppRouter from './router/AppRouter';
import { AppProvider } from './context/AppContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PhotoUpload from './components/PhotoUpload';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* PhotoUpload 路由独立，不被 AppProvider 包裹 */}
          <Route path="/upload/:templateId" element={<PhotoUpload />} />
          
          {/* 其他所有路由都被 AppProvider 包裹 */}
          <Route path="*" element={
            <AppProvider>
              <AppRouter />
            </AppProvider>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
